import { DatePicker } from '@bitcine/cinesend-theme/dist'

const Date = ({ type, asset, saveAsset, disabled }) => {
  const key = type === 'Start' ? 'start_date' : 'end_date'
  return (
    <>
      {(type === 'Start' || type === 'End') && (
        <DatePicker
          label={`${type} Date`}
          useLocal={false}
          date={asset[key]}
          dateFormat={'yyyy-MM-dd'}
          showTimeSelect={false}
          onChange={(newDate) => saveAsset({ [key]: newDate })}
          disabled={disabled}
        />
      )}
    </>
  )
}

export default Date
